import urlParameters from '../util/urlParameters'
import { backendUrl } from '../util/endpointConfig'
import { serializeObject, deserializeObject } from '../util/soundDataSerializer'
import { initialSoundData } from './../data/soundData'
import { store } from '../store/store'

const endpoint = backendUrl + 'soundwave/'
let app
let _isLoadingInitialState = false

export async function init(_app) {
  app = _app // This stuff is needed right now because the save function acceses the poster information via app
  const urlParas = urlParameters()
  let initState = {}

  const posterId = urlParas.posterId
  // This means the app was called withou a posterID, thus we create a new smoster in the BE and set efault values in app
  if (posterId === undefined) {
    initState = {
      posterState: {
        layout: 'classic-svg',
        style: 'thin',
        colorClassic: 'schneeweiss',
        options: {
          hasFrame: true,
          hasGrid: false,
          useAlternativeFont: false,
        },
        visualOptions: {
          cutSilence: true,
          enhanceAudio: true,
        },
        date: '',
        heading: 'You are my special one',
        dedication: '',
        playbackOptions: {
          qrCode: true,
        },
      },
      soundData: {
        straight: deserializeObject(initialSoundData.straight),
        fourier: initialSoundData.fourier,
      },
      isRecording: true,
    }
  } else {
    store.commit('setInitialPosterId', posterId)
    store.commit('setIsPrintMode',  !!urlParas.printMode && urlParas.printMode === 'true')
    store.commit('setIsEditMode',  !!urlParas.edit && urlParas.edit === 'true')

    // If we call the app with a posterId in the URL we want to fetch all data for that Poster
    const url = endpoint + posterId
    const posterResponse = await fetch(url, {
      method: 'GET',
    })

    if (!posterResponse.ok) {
      throw new Error(
        `Request for poster ${posterResponse.url} failed with code ${posterResponse.status}. Are you talking to the correct backend?`
      )
    }
    const posterData = await posterResponse.json()

    store.commit('setSmosterId', posterData.smosterId)
    store.commit('setInitialPosterId', posterId)
    
    initState = {
      posterState: posterData.posterState,
      soundData: {
        straight: deserializeObject(posterData.soundData.straight),
        fourier: posterData.soundData.fourier,
      },
    }

    // since playback and qr code were added later
    if (!posterData.posterState.playbackOptions) {
      initState.posterState.playbackOptions = {
        qrCode: false,
      }
    }
  }

  return initState
}

export async function savePoster() {
  const smosterId = store.state.smosterId

  const state = {
    posterState: app.posterState,
    soundData: {
      straight: serializeObject(app.soundData.straight),
      fourier: app.soundData.fourier,
      duration: app.soundData.duration,
    },
    smosterId: smosterId,
  }

  if (!smosterId) {
    throw new Error(
      `save function is missing data state.smosterId: ${smosterId}`
    )
  }

  const url = endpoint
  const posterSavingRequest = await fetch(url, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
    },
    body: JSON.stringify(state),
  })
  if (!posterSavingRequest.ok) {
    throw new Error(
      `Request for poster ${posterSavingRequest.url} failed with code ${posterSavingRequest.status}. Are you talking to the correct backend?`
    )
  }

  return posterSavingRequest.text()
}

export function isLoadingInitialState() {
  return _isLoadingInitialState
}
